import PropTypes from "prop-types";

const propTypes = {
  onAnswerClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default propTypes;
